import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PropertyAvailabilityRulesComponent } from '@app/modules/properties/pages/property-availability-rules/property-availability-rules.component';
import { FullScreenModalComponent } from '@app/shared/layouts/full-screen-modal/full-screen-modal.component';
import { CreateBookingListingDialogComponent } from './components/create-booking-listing-dialog/create-booking-listing-dialog.component';
import { PropertiesComponent } from './pages/properties/properties.component';
import { PropertyDetailComponent } from './pages/property-detail/property-detail.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'segments/default',
    pathMatch: 'full',
  },
  {
    path: 'segments/:activeSegment',
    component: PropertiesComponent,
    data: {
      title: 'Properties',
      identifier: 'property',
      shouldReuse: false,
    },
  },
  {
    path: 'property/:id',
    redirectTo: 'property/:id/merge-match',
  },
  {
    path: 'property/:id/create-booking-listing',
    component: FullScreenModalComponent,
    data: {
      closeLink: '/properties/property/:id',
      shouldReuse: false,
    },
    children: [
      {
        path: '',
        component: CreateBookingListingDialogComponent,
        data: {
          title: 'Create Booking.com Property',
        },
      },
    ],
  },
  {
    path: 'property/:id/availability-rules',
    component: PropertyAvailabilityRulesComponent,
    data: {
      title: 'Property availability rules',
      shouldReuse: false,
    },
  },
  {
    path: 'property/:id/:area',
    component: PropertyDetailComponent,
    data: {
      title: 'Property detail',
      shouldReuse: false,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PropertiesRoutingModule {}
